import { jsx as _jsx } from "react/jsx-runtime";
import keyBy from "lodash/keyBy";
import { memo, useCallback, useMemo } from "react";
import { Select } from "~/components/Select/Select";
import { CUSTOM_FIELD_VALUE_SELECT } from "~/constants/testIDs";
import { convertCustomFieldValueToFilterOption } from "./utils";
export const CustomFieldValuesFilterSelect = /*#__PURE__*/ memo((param)=>{
    let { placeholder = "Select field values", onSelectedValuesChanged, selectedValues, values, ...props } = param;
    const options = useMemo(()=>values.map((value)=>convertCustomFieldValueToFilterOption(value)), [
        values
    ]);
    const selectedOptions = useMemo(()=>selectedValues.map((value)=>convertCustomFieldValueToFilterOption(value)), [
        selectedValues
    ]);
    const onSelectionChange = useCallback((param)=>{
        let { chips } = param;
        const valuesById = keyBy(values, "id");
        const selected = chips.map((param)=>{
            let { value } = param;
            return valuesById[value];
        });
        onSelectedValuesChanged(selected);
    }, [
        onSelectedValuesChanged,
        values
    ]);
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": CUSTOM_FIELD_VALUE_SELECT,
        options: options,
        selectedOptions: selectedOptions,
        isSearchable: true,
        maxDropdownHeight: 300,
        onSelectionChange: onSelectionChange,
        placeholder: placeholder,
        renderAsInput: true,
        ...props
    });
});
CustomFieldValuesFilterSelect.displayName = "CustomFieldValuesFilterSelect";
